export default (targetRoles, viewerRoles, list) => list.filter(
	({roles, hiddenFor}) => !hiddenFor.some(
		hiddenForRole => viewerRoles.includes(hiddenForRole)
	) && roles.some(
		purposedToRole => targetRoles.includes(purposedToRole)
	)
);
